import classNames from "classnames";
import dateformat from "dateformat";
import PropTypes from "prop-types";
import QRCode from "qrcode.react";
import React from "react";
import TriggerEvents from "../shared/utils/trigger.events";
import dataProvider from "./dataProvider.js";

const triggerEvents = TriggerEvents();

class MediaEvent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getEvent(event_id) {
    // let cache_ttl_seconds = this.props.cache_ttl_min * 60
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    let fetchURL = apiBaseUrl + "/event";
    let fetchParams = {
      id: event_id,
      facebook_access: this.props.facebook_access,
      cache_ttl: 30 * 60
    };
    let maxAgeMinute = this.props.cache_ttl_min; // this.props.cache_ttl //  // 0.1 // hack for 0.1 ---->  30  // mins
    // const pageLikesInfo = ''

    dataProvider
      .getFbEvent(fetchURL, fetchParams, maxAgeMinute)
      .then(result => {
        console.log("getEvent result = ", result);
        if (result === null) {
          throw new Error("Event not found");
        }
        // this.updateResultToRender(finalResult)
        this.setState({
          fb_event: result
        });
      })
      .catch(error => {
        console.warn(
          "Failed to get data for " + fetchURL + ", params = ",
          fetchParams,
          error
        );
        if (!this.state.preload) {
          triggerEvents.sendErrorEvent();
        }
      });
  }

  componentDidMount() {
    this.getEvent(this.props.id);
  }

  render() {
    let event = this.state.fb_event;

    if (!event) {
      return <div />;
    } else {
      let mediaBg = {
        backgroundImage: "url(" + this.props.image + ")"
      };

      let animClass = "";

      if (this.props.preload === true) {
        animClass = "col-md-6";
      }

      let eventDate = event.start_time.slice(0, 10).replace(/-/g, "/");
      let description = this.props.description;

      if (event.name.length > 50) {
        event.name = event.name.slice(0, 50) + "...";
      }
      if (description.length > 150) {
        description = description.slice(0, 150) + "...";
      }

      const descriptionClass = classNames("desc", {
        "hidden-qr": !this.props.displayQr
      });

      return (
        <div id="media" className={animClass}>
          <div className="thumbnail" style={mediaBg} />
          <div className={descriptionClass}>
            <div id="calendar">
              <h2>{dateformat(eventDate, "mmm")}</h2>
              <h1>{dateformat(eventDate, "d")}</h1>
            </div>

            <h1 className="event-name">{event.name}</h1>
            <h2 className="event-desc">{description}</h2>

            {this.props.displayQr && (
              <QRCode value={this.props.link} level="L" />
            )}
          </div>
        </div>
      );
    }
  }
}

MediaEvent.propTypes = {
  facebook_access: PropTypes.string,
  displayQr: PropTypes.bool,
  link: PropTypes.string,
  id: PropTypes.string,
  image: PropTypes.string,
  description: PropTypes.string,
  cache_ttl_min: PropTypes.number,
  preload: PropTypes.bool
};

export default MediaEvent;
